/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_Q3Inputs */

const en_dr_faq_q3 = /** @type {(inputs: Dr_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which language does it run in?`)
};

const id_dr_faq_q3 = /** @type {(inputs: Dr_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa apa yang dipakai?`)
};

/**
* | output |
* | --- |
* | "Which language does it run in?" |
*
* @param {Dr_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_q3 = /** @type {((inputs?: Dr_Faq_Q3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_Q3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_q3(inputs)
	return en_dr_faq_q3(inputs)
});